<template>
  <div class="addFile">
    <div class="arrange">
      <div class="title">
        <strong>会诊安排</strong>
      </div>
      <div class="formContent">
        <mt-field :disabled="isDisabled" label="患者姓名" placeholder="请输入" v-model="ruleForm.name"></mt-field>
        <mt-field :disabled="isDisabled" label="年龄" placeholder="请输入" type="number" v-model="ruleForm.age"></mt-field>
        <!-- <mt-radio title="性别" :options="options" v-model="ruleForm.sex"></mt-radio> -->
        <!-- <mt-field class="yy" :disabled="isDisabled" label="病情简介/会诊原因" placeholder="请输入" type="textarea" rows="3" v-model="ruleForm.illnessRemark"></mt-field> -->
        <div class="radioGroup">
          <span>性别</span>
          <div class="radio-inline">
            <input disabled v-model="ruleForm.sex" id="man" type="radio" name="sex" value="男" checked/>
            <label for="man">男</label>
          </div>
          <div class="radio-inline">
            <input disabled v-model="ruleForm.sex" id="woman" type="radio" name="sex" value="女" />
            <label for="woman">女</label>
          </div>
        </div>
        <div class="text-area">
          <label for="bq">病情简介/会诊原因</label>
          <textarea :disabled="isDisabled" id="bq" cols="35" rows="5" placeholder="请输入" v-model="ruleForm.illnessRemark"></textarea>
        </div>
        <div class="select-wrapper">
          <p>
            <label for="hzHospital">会诊医院</label>
            <select :disabled="isDisabled" name="" id="hzHospital" class="hzHospital" placeholder="请输入" v-model="ruleForm.diagnosisHospital">
              <option value="" disabled selected hidden>请输入</option>
              <option :value="item.id" v-for="(item, index) in applyHospitalList" :key="index">{{item.hospitalName}}</option>
            </select>
          </p>
          <p>
            <label for="hzHospital">会诊医生</label>
            <select name="" id="hzHospital" class="hzHospital" placeholder="请输入" v-model="ruleForm.diagnosisDoctor">
              <option value="" disabled selected hidden>请输入</option>
              <option :value="item.id" v-for="(item, index) in consultationDoctors" :key="index">{{item.userName}}</option>
            </select>
          </p>
        </div>
        <mt-field style="ime-mode:disabled;" v-model="ruleForm.diagnosisDate" label="选择日期" placeholder="请输入" type="datetime" @focus.native.capture="openData"></mt-field>
        <mt-datetime-picker
          ref="picker"
          type="datetime"
          v-model="pickerValue"
          @confirm="handleConfirm"
          :startDate="startDate">
        </mt-datetime-picker>
        <mt-field :disabled="isDisabled" label="备注" placeholder="请输入" type="text" v-model="ruleForm.remark"></mt-field>
        <div class="select-wrapper">
          <p>
            <label for="hzHospital">邀请医院</label>
            <select name="" id="hzHospital" class="hzHospital" placeholder="请输入" v-model="ruleForm.invitationHospital" @change="changeInvitationHospital(ruleForm.invitationHospital)">
              <option value="" disabled selected hidden>请输入</option>
              <option :value="item.id" v-for="(item, index) in invitationHospitalList" :key="index">{{item.hospitalName}}</option>
            </select>
          </p>
          <p>
            <label for="hzHospital">邀请医生</label>
            <select name="" id="hzHospital" class="hzHospital" placeholder="请输入" v-model="ruleForm.invitationDoctor">
              <option value="" disabled selected hidden>请输入</option>
              <option :value="item.id" v-for="(item, index) in invitationDoctorList" :key="index">{{item.userName}}</option>
            </select>
          </p>
        </div>
        <!-- <mt-radio title="是否同意" :options="['是', '否']" v-model="isAgree"></mt-radio> -->
        <div class="radioGroup">
          <span>是否同意</span>
          <div class="radio-inline">
            <input v-model="isAgree" id="ok" type="radio" name="isAgree" value="是" />
            <label for="ok">是</label>
          </div>
          <div class="radio-inline">
            <input v-model="isAgree" id="not" type="radio" name="isAgree" value="否" />
            <label for="not">否</label>
          </div>
        </div>
        <p style="padding-left:2%;" class="boardroom">
          <label for="hzHospital">会议室</label>
          <select name="" id="hzHospital" class="hzHospital" placeholder="请输入" v-model="ruleForm.boardroom">
            <option value="" disabled selected hidden>请输入</option>
            <option :value="item.hospitalId" v-for="(item, index) in boardroomList" :key="index">{{item.hospitalName}}</option>
          </select>
        </p>
        <p style="padding-left:2%;" class="reason-radio" v-if="isAgree == '否'">
          <label for="reasonRadio" class="reason-label">拒绝原因</label>
          <mt-checklist
            v-model="reasonRadio"
            @change="reasonRadioChange"
            id="reasonRadio"
            align="right"
            :options="['延期', '系统错误', '申请错误']">
          </mt-checklist>
        </p>
        <mt-field v-if="isAgree == '否'" label="拒绝原因" placeholder="请输入" v-model="ruleForm.reason"></mt-field>
        <div class="btn-wrapper">
          <p class="btn" style="text-align:right;padding-right:2%;margin-bottom:15px;">
            <mt-button type="default" size="small" @click="cancel">取消</mt-button>
            <!-- <mt-button v-if="isAgree == '否'" type="default" size="small" @click="reason">拒绝</mt-button> -->
            <!-- <el-button v-if="radio2 == 0" type="primary" @click="reason()" size="small">拒 绝</el-button> -->
            &emsp;
            <mt-button type="primary" size="small" @click="handleSubmit">确定</mt-button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { Indicator } from 'mint-ui'
import { MessageBox } from 'mint-ui'
import moment from 'moment'
export default {
  data() {
    return {
      reasonRadio: [],
      pickerValue: '',
      startDate: '',
      isDisabled: false,
      id: this.$route.query.rid,  //会诊申请id
      type: this.$route.query.type,
      topHospitalId: localStorage.getItem('HospitalID'),  //登录医院id
      applyHospitalList: [],  //会诊医院
      consultationDoctors: [],  //会诊医生
      invitationDoctorList: [], 
      invitationHospitalList: [], 
      boardroomList: [],  //会议室
      isAgree: '是',
      ruleForm: {
        name: '',
        sex: '男',
        age: '',
        firstDiagnosis: '', //初步判断
        illnessRemark: '',  //会诊原因
        diagnosisHospital: '',  //会诊医院
        diagnosisDoctor: '',  //会诊医生
        diagnosisDate: '',  //会诊时间
        remark: '',
        invitationDoctor: '',
        invitationHospital: '',
        isCommit: '', //是否同意
        boardroom: '', //会议室
        records: '',
        reason: ''  //拒绝原因
      },
      // options: [{
      //   label: '男',
      //   value: '男',
      //   disabled: true
      // }, {
      //   label: '女',
      //   value: '女',
      //   disabled: true
      // }]
    }
  },
  created() {
    // let curDate = new Date()
    // this.startDate = new Date(curDate.getTime() - 60*60*1000); //前一天
    this.startDate = new Date()
    // 获取所有会诊医院
    this.getApplyHospitalList()
    // console.log(this.type)
    this.getBoardroom()
    // 获取所有邀请医院
    this.getInvitateHospital()
  },
  methods: {
    // 选择拒绝原因
    reasonRadioChange() {
      if (this.reasonRadio.length === 2) {
        this.reasonRadio.shift()
      }
      this.$set(this.ruleForm, 'reason', this.reasonRadio[0])
    },
    // 重置表单
    resetForm() {
      for (let item in this.ruleForm) {
        if (item == 'diagnosisDate') {
          this.ruleForm[item] = null
        }
        this.ruleForm[item] = ''
        this.file = null
      }
      this.close()
    },
    // 点击拒绝按钮
    reason() {
      if (this.ruleForm.reason == '' || this.ruleForm.reason == undefined) {
        Toast({
          message: '请填写拒绝原因!',
          position: 'top',
          duration: 1500
        });
        return
      }
      Indicator.open("加载中...")
      this.Axios.put('/api/Remote/DisagreeRemote?id='+ this.id + '&disagreeReason=' + this.ruleForm.reason).then(res => {
        const data = res.data
        Indicator.close()
        if (data.status === 100) {
          Toast({
            message: '操作成功!',
            position: 'top',
            duration: 1500
          });
          this.$router.push({
            name: 'Consultation'
          })
        } else {
          Toast({
            message: '操作失败请重试,或联系管理员!',
            position: 'top',
            duration: 1500
          });
        }
      })
    },
    // 点击取消按钮回到会诊页
    cancel() {
      this.$router.push({
        name: 'Consultation'
      })
    },
    // 获取所有会诊医院
    getApplyHospitalList() {
      this.Axios.get('/api/Hospital/GetSuperiorHospital?hospitalID=' + this.topHospitalId)
        .then(res => {
          let data = res.data
          if (data.status == 100) {
            // this.isShowConsultation = true
            this.applyHospitalList = data.data
            // 初始化数据
            this.arrange()
          } else if (data.status == 101) {
            console.log('没有上级医院')
          }
        })
        .catch(error => {
          Toast({
            message: '网络错误,请联系管理员!',
            position: 'top',
            duration: 1500
          });
        })
    },
    // 根据会诊医院获取会诊医生
    changeHospital(id) {
      this.Axios.get('/api/Hospital/GetDoctorByHId?hospitalId=' + id)
        .then(res => {
          // this.ruleForm.diagnosisDoctor = null
          let data = res.data
          if (data.status == 100) {
            // this.commonForm.diagnosisDoctor = null
            this.consultationDoctors = data.data
          } else {
            this.consultationDoctors = null
            Toast({
              message: '该医院下没有医生',
              position: 'top',
              duration: 1500
            });
          }
        })
        .catch(error => {
          Toast({
            message: '网络错误请联系管理员!',
            position: 'top',
            duration: 1500
          });
      })
    },
    openData() {
      this.$refs.picker.open()
      document.activeElement.blur()
    },
    // 选择时间
    handleConfirm() {
      this.ruleForm.diagnosisDate = this.pickerValue
      this.ruleForm.diagnosisDate = moment(new Date(this.ruleForm.diagnosisDate)).format('YYYY-MM-DD HH:mm')
    },
    // 获取邀请医院
    getInvitateHospital() {
      this.Axios.get('/api/Hospital/GetAllHospital')
        .then(res => {
          let data = res.data
          this.invitationHospitalList = data.data
        })
        .catch(error => {
          Toast({
            message: '网络错误,请联系管理员!',
            position: 'top',
            duration: 1500
          });
        })
    },
    // 根据邀请医院获取医院下的所有医生
    changeInvitationHospital(id) {
      this.Axios.get('/api/Hospital/GetDoctorByHId?hospitalId=' + id).then(res => {
        // console.log('相应医院的医生',res.data)
        let data = res.data
        if (data.status == 100) {
          this.ruleForm.invitationDoctor = null
          this.invitationDoctorList = data.data
        }
      })
      .catch(error => {
        Toast({
          message: '网络错误,请联系管理员!',
          position: 'top',
          duration: 1500
        });
      })
    },
    // 获取会议室
    getBoardroom() {
      this.Axios.get('/api/User/GetUserInfo')
        .then(res => {
          let data = res.data
          if (data.status == 100) {
            this.boardroomList = data.ret.boardroom.value
            // console.log('会议室', this.boardroomList)
          }
        })
        .catch(error => {
          Toast({
            message: '网络错误,请联系管理员!',
            position: 'top',
            duration: 1500
          });
        })
    },
    // 进入安排页面初始化数据
    arrange() {
      this.isDisabled = true
      this.Axios.get('/api/Remote/GetRemoteConById?id=' + this.id)
        .then(res => {
          const data = res.data
          // console.log(data)
          if (data.status == 100) {
            data.data.diagnosisDate = moment(data.data.diagnosisDate).format('YYYY-MM-DD HH:mm')
            // console.log('安排', data.data)
            data.data.sex == 1 ? data.data.sex = '男' : data.data.sex = '女'
            this.ruleForm = Object.assign(this.ruleForm, data.data)
            // console.log(222, this.ruleForm)
            const hospitalId = data.data.diagnosisHospital
            this.applyHospitalList = [{
              id: data.data.diagnosisHospital,
              hospitalName: data.data.diagnosisHospitalName
            }]
            this.ruleForm.diagnosisHospital = data.data.diagnosisHospital
            // this.ruleForm.diagnosisDoctor = data.data.diagnosisDoctor
            this.changeHospital(this.ruleForm.diagnosisHospital)
          }
        })
        .catch(error => {
          Toast({
            message: '网络错误,请联系管理员!',
            position: 'top',
            duration: 1500
          });
      })
    },
    doSaveArrange() {
      let formData = {
        invitationHospital: this.ruleForm.invitationHospital,
        invitationDoctor: this.ruleForm.invitationDoctor,
        diagnosisDate: this.ruleForm.diagnosisDate,
        diagnosisDoctor: this.ruleForm.diagnosisDoctor,
        boardroom: this.ruleForm.boardroom
      }
      Indicator.open("加载中...")
      this.Axios.get('/api/User/JudgeBoardroomInfo?time=' + moment(this.ruleForm.diagnosisDate).format('YYYY-MM-DD HH:mm:ss') +
          '&boardroomId=' + this.ruleForm.boardroom
      ).then(res => {
        Indicator.close()
        if (res.data.flag && res.data.status === 100) {
          MessageBox.confirm('会议时间段有冲突，是否继续？').then(action => {
            this.Axios.put('/api/Remote/RemoteArrange?id=' + this.ruleForm.id, formData).then(res => {
              let data = res.data
              if (data.status == 100) {
                Toast({
                  message: '安排成功!',
                  position: 'top',
                  duration: 1500
                });
                // this.resetForm()
                this.$router.push({
                  name: 'Consultation'
                })
              } else if (data.status === 102) {
                Toast({
                  message: '添加瞩目会议室失败！会议室信息不正确，请联系管理员',
                  position: 'top',
                  duration: 1500
                });
              } else {
                Toast({
                  message: '添加失败!',
                  position: 'top',
                  duration: 1500
                });
              }
            })
            .catch(error => {
              Toast({
                message: '网络错误,请联系管理员!',
                position: 'top',
                duration: 1500
              });
            })
          }).catch(() => {
            Toast({
              message: '已取消!',
              position: 'top',
              duration: 1500
            });
          })
        } else if (!res.data.flag && res.data.status === 100) {
          //没有冲突
          this.Axios.put(
            '/api/Remote/RemoteArrange?id=' + this.id,
            formData
          )
            .then(res => {
              let data = res.data
              if (data.status == 100) {
                Toast({
                  message: '安排成功!',
                  position: 'top',
                  duration: 1500
                });
                this.$router.push({
                  name: 'Consultation'
                })
              } else if (data.status === 102) {
                Toast({
                  message: '添加瞩目会议室失败！会议室信息不正确，请联系管理员!',
                  position: 'top',
                  duration: 1500
                });
              }
            })
            .catch(error => {
              Toast({
                message: '网络错误,请联系管理员!',
                position: 'top',
                duration: 1500
              });
            })
        } else {
          Toast({
            message: '网络错误,请联系管理员!',
            position: 'top',
            duration: 1500
          });
        }
      }).catch(error => {
        Indicator.close()
        Toast({
          message: '网络错误,请联系管理员!',
          position: 'top',
          duration: 1500
        });
      })
    },
    handleSubmit() {
      if (this.isAgree == '否') {
        this.reason()
      } else {
        this.doSaveArrange()
      }
    },
  }
}
</script>

<style lang="less">
.addFile {
  height: 99%;
  overflow: auto;
  // border: 1px solid rebeccapurple;
  .arrange {
    height: 100%;
    // border: 1px solid rebeccapurple;
    .title {
      font-size: 14px;
      height: 3%;
      padding: 2% 2%;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      background: #f5f5f9;
    }
    .formContent {
      .radioGroup {
        height: 48px;
        line-height: 48px;
        padding: 0 10px;
        // border-top: 1px dotted #ccc;
        // border-bottom: 1px dotted #ccc;
        span {
          width: 105px;
          display: block;
          float: left;
        }
        .radio-inline {
          float: left;
          margin-right: 10px;
          input[type="radio"] + label::before {
            content: "\a0";
            display: inline-block;
            vertical-align: middle;
            width: 10px;
            height: 10px;
            margin-right: 5px;
            border-radius: 50%;
            text-indent: .15em;
            margin-bottom: 4px;
            border: 1px solid #CCCCCC;
            padding: 2px;
          }
          input[type="radio"] {
            position: absolute;
            clip: rect(0, 0, 0, 0);
          }
          input[type="radio"]:checked + label::before {
            background-color: #4A90E2;
            background-clip: content-box;
            padding: 2px;
          }
        }
      }
      .text-area {
        padding-left: 10px;
        padding-right: 5px;
        margin-top: 16px;
        display: flex;
        &::after {
          content: "";
          display: block;
          width: 0;
          height: 0;
          clear: both;
        }
        textarea {
          outline: none;
          flex: 1;
          border: 1px solid #ccc;
          float: right;
        }
        label {
          display: block;
          width: 105px;
          // border: 1px solid rebeccapurple;
          float: left;
          top: 0;
        }
      }
      .select-wrapper {
        padding-left: 2%;
        .hzHospital{
          background: rgba(0,0,0,0);
          width: 55%;
          height: 32px;
          font-family: "微软雅黑";
          font-size: 18px;
          color: #000;
          border: 1px #ccc solid;
          border-radius: 5px;
          // margin-left: 2%;
          outline: none;
          &:focus{
            border: 1px #ddd solid;
            box-shadow: 0 0 15px 1px #DDDDDD;
          }
          option{
            color: black;
            background: white;
            line-height: 20px;
            // &:hover{
            //   background: #EBCCD1;
            // }
          }
        }
        label {
          display: inline-block;
          width: 105px;
        }
      }
      .upload-wrapper {
        padding-left: 2%;
        font-size: 14px;
        .btn-wrapper {
          overflow: hidden;
          padding-right: 2%;
          .download {
            float: left;
            background: url('../../assets/u313.png') no-repeat;
            text-indent: 5%;
            margin-top: 6%;
          }
          .btn {
            float: right;
          }
        }
      }
      .boardroom {
        padding-left: 2%;
        label {
          display: inline-block;
          width: 105px;
        }
        .hzHospital{
          background: rgba(0,0,0,0);
          width: 55%;
          height: 32px;
          font-family: "微软雅黑";
          font-size: 18px;
          color: #000;
          border: 1px #ccc solid;
          border-radius: 5px;
          // margin-left: 2%;
          outline: none;
          &:focus{
            border: 1px #ddd solid;
            box-shadow: 0 0 15px 1px #DDDDDD;
          }
          option{
            color: black;
            background: white;
            line-height: 20px;
            // &:hover{
            //   background: #EBCCD1;
            // }
          }
        }
      }
      .reason-radio {
        padding-left: 2%;
        .reason-label {
          display: inline-block;
          width: 105px;
        }
        .mint-radiolist-title {
          display: none;
        }
        .mint-cell {
          min-height: 36px;
        }
      }
    }
  }
  input[disabled="disabled"] {
    border-radius: 4px;
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder, select {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-moz-placeholder, textarea::-moz-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-ms-input-placeholder, textarea::-ms-input-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
}
</style>
